module.exports = __webpack_public_path__ + "img/emitEnhanceface01.f8aae6c4.png";